export default __webpack_public_path__ + "static/media/falling-bart.064ac5aa.png";